import { render } from "./ReferalFromApps.vue?vue&type=template&id=5cabb5d9&scoped=true"
import script from "./ReferalFromApps.vue?vue&type=script&lang=js"
export * from "./ReferalFromApps.vue?vue&type=script&lang=js"

import "./ReferalFromApps.vue?vue&type=style&index=0&id=5cabb5d9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cabb5d9"]])

export default __exports__